/* -------------------------------------------------------------------------- */
/* Shared styles for all HTML skins                                           */
/* -------------------------------------------------------------------------- */

media-tooltip-group,
media-dialog,
media-alert-dialog,
media-error-dialog,
media-controls {
  display: contents;
}

:host {
  /* `display:grid` fixes a weird issue with Safari when setting aspect-ratio */
  display: grid;
  width: 100%;
}

media-container {
  min-width: 0;
  min-height: 0;
}

/* Hide the volume popover when its slider is unavailable. */
.media-popover--volume:has(media-volume-slider[data-hidden]) {
  display: none;
}
